// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"widget-space--wrapper--3p82C"};